exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".CampaignDashboard-count-2E6lu,.CampaignDashboard-rate-3MnFp{display:block;margin-top:20px;font-size:100px;font-weight:lighter;line-height:1}.CampaignDashboard-answerGroup-1-bIj{margin:0;padding:0;list-style-type:none}.CampaignDashboard-answerGroup-1-bIj>li{display:block}.CampaignDashboard-answerGroup-1-bIj>li h4{text-transform:none;text-align:center}.CampaignDashboard-answerGroup-1-bIj>li p{margin:10px 0 0}.CampaignDashboard-answerCount-2d5QY{text-align:center}.CampaignDashboard-answerCount-2d5QY.CampaignDashboard-danger-2E9dD .CampaignDashboard-count-2E6lu{color:#ff5766}.CampaignDashboard-answerCount-2d5QY .CampaignDashboard-count-2E6lu{color:#00e5ce}.CampaignDashboard-answerRate-1B2L1{text-align:center}.CampaignDashboard-answerRate-1B2L1.CampaignDashboard-danger-2E9dD .CampaignDashboard-rate-3MnFp{color:#ff5766}.CampaignDashboard-answerRate-1B2L1 .CampaignDashboard-rate-3MnFp{color:#00e5ce}", ""]);

// exports
exports.locals = {
	"count": "CampaignDashboard-count-2E6lu",
	"rate": "CampaignDashboard-rate-3MnFp",
	"answerGroup": "CampaignDashboard-answerGroup-1-bIj",
	"answerCount": "CampaignDashboard-answerCount-2d5QY",
	"danger": "CampaignDashboard-danger-2E9dD",
	"answerRate": "CampaignDashboard-answerRate-1B2L1"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/satisfaction/components/CampaignDashboard.less
// module id = 1749
// module chunks = 0